import { render, staticRenderFns } from "./fccClassificacaoBusca.vue?vue&type=template&id=13f3615f"
import script from "./fccClassificacaoBusca.vue?vue&type=script&lang=js"
export * from "./fccClassificacaoBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports